import React, { useEffect } from 'react';
import Tracking from './../tracking';

type TrackEmptyProps = {
    tracking: Tracking;
    onEmpty?: () => void;
};
const TrackEmpty: React.FC<TrackEmptyProps> = ({ tracking, onEmpty }) => {
    useEffect(() => {
        tracking.trackEmpty();
    }, [tracking]);

    useEffect(() => {
        if (onEmpty) onEmpty();
    }, [onEmpty]);

    return null;
};

export default TrackEmpty;
